import {propValue} from 'utils/Helper';

export default theme => ({
  root: {
    padding: propValue('spacing', 8),
    position: 'relative'
  },
  inputRoot: {
    border: '0.0625rem solid #eaeaea',
    '&:focus': {
      border: '1px solid #8a8a8a',
      background: 'transparent none repeat scroll 0 0',
      backgroundColor: '#fefefe',
      outline: 'none',
      boxShadow: '0 0 5px #cacaca',
      transition: 'box-shadow .5s,border-color .25s ease-in-out',
    }
  },
  textareaRoot: {
    alignItems: 'start',
  },
  adornedStart: {
    height: 'auto',
  },
  input: {
    // background: 'transparent none repeat scroll 0 0',
    borderRadius: 0,
    boxShadow: 'none',
    outline: 'medium none',
    textIndent: props => {
      // return props.icon ? 25 : 0
    },
    padding: props => {
    //  return props.type === 'button' ? '10px 20px' : '0 0.40rem'
   },
  //  fontSize: '0.6875rem',
   transition: 'all 0.2s ease 0s',

   display: 'block',
  //  width: '100%',
   height: '1.6rem',
   lineHeight: '1.6rem',
   fontSize: '1rem',

   '&::placeholder': {color: '#ccc'},
  },
  textarea: {
    maxWidth: '100%',
    // paddingTop: 8,
    minHeight: 50
  },
  label: {
  },
  icon: {
    fontSize: 15,
    top: 0,
    // position: 'absolute',
    // top: 23,
    // right: props => {return 18},
  },
  buttonIcon: {
    fontSize: 17,
    marginLeft: 5,
    marginRight: 0,
    position: 'initial'
  },
  hint: {
    fontSize: 14,
    color: '#f00',
  }
});